<template>
    <form :action="response.url" method="post" target="_self">
        <input type="hidden"
               v-for="(key, index) in response.post"
               :key="index"
               :name="index"
               :value="key">
    </form>
</template>

<script>
    export default {
        name: 'RedirectPostForm',
        props: {
            response: {
                type: Object,
                required: true,
            },
        },
        mounted() {
            this.$el.submit();
        },
    };
</script>
